const getters = {
   sidebar: state => state.app.sidebar,
   size: state => state.app.size,
   device: state => state.app.device,
   topbarRouters:state => state.permission.topbarRouters,
   defaultRoutes:state => state.permission.defaultRoutes,
   sidebarRouters:state => state.permission.sidebarRouters,
   permissions: state => state.user.permissions,
   permission_routes: state => state.permission.routes,

   /* 全局的几个标准代码 start */
   loginUserInfo: state => state.appstore.loginUserInfo,  // 登录人员的用户信息
   menu: state => state.appstore.menu,  // 面包屑
   workerObj: state => state.appstore.workerObj,  // 当前正在处理的工单对象,
   token: state => state.appstore.token,  // token凭证
   baseUrl: state => state.appstore.baseUrl, // 基础路由

};

export default getters;
